import React from "react";

export const InputField = ({
  label,
  type,
  name,
  handlechange,
  value,
  options,
  error,
  ...other
}) => {
  return (
    <div className="w-full md:w-1/2 px-2">
      <div className="w-full capitalize">
        <label
          className="block text-sm font-medium text-gray-700 mb-1"
          htmlFor={label}
        >
          {label}
        </label>
        {type === "select" ? (
          <select
            className={`block w-full py-3 mt-1 text-sm text-gray-700 bg-white border rounded-md shadow-sm text-left ${error ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
              }`}
            style={{ height: "48px", paddingLeft: "0", paddingRight: "0", marginLeft: "0" }} // No padding or margin
            value={value}
            onChange={handlechange}
            id={label}
            name={name}
            {...other}
          >
            {(options || []).map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        ) : (
          <input
            className={`block w-full py-3 mt-1 text-sm text-gray-700 bg-white border rounded-md shadow-sm text-left ${error ? "border-red-500 focus:ring-red-500" : "border-gray-300 focus:ring-blue-500"
              }`}
            style={{ height: "48px", paddingLeft: "0", paddingRight: "0", marginLeft: "0" }} // No padding or margin
            type={type}
            value={value || ""}
            onChange={handlechange}
            id={label}
            name={name}
            autoComplete="off"
            {...other}
          />
        )}
      </div>
    </div>
  );
};

export const InputWtLabel = ({ name, type, handlechange, value, ...other }) => {
  return (
    <div className="w-full md:w-1/3">
      <input
        className="block w-full py-3 text-sm text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm text-left placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        style={{ height: "48px", paddingLeft: "0", paddingRight: "0", marginLeft: "0" }} // No padding or margin
        type={type}
        value={value}
        name={name}
        onChange={handlechange}
        {...other}
      />
    </div>
  );
};
